import { render, staticRenderFns } from "./RegistrationIBAN.vue?vue&type=template&id=71daff8e&"
import script from "./RegistrationIBAN.vue?vue&type=script&lang=ts&"
export * from "./RegistrationIBAN.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports